import { useState } from "react";
import { useLocation } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Box, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import CardMedia from "@mui/material/CardMedia";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import type { ChangeEvent, MouseEvent } from "react";
import PopoverRegister from "../../../components/PopoverRegister";
import ImageIcon from "../../../assets/images/l_e_others_501.png";
import { createIcon } from "../../../api";
import type { IconFormState, IconTableColumn } from "../../../types/icon";

type IconAddictionProps = {
  open: boolean;
  onClose: (event: MouseEvent) => void;
  columns: IconTableColumn[];
  tenantId?: string | null;
};

export default function IconAddiction({
  open,
  onClose,
  columns,
}: IconAddictionProps) {
  const [icons, setIcons] = useState<IconFormState>({
    alive: false,
    sales: false,
    sale_status: false,
    damage: false,
  });

  const searchParams = new URLSearchParams(useLocation().search);
  const tenantId = searchParams.get("tenant_id");
  const tenantName = searchParams.get("name");

  const checkboxAction = (event: MouseEvent) => {
    event.stopPropagation();
  };

  const CheckboxValidate = (input: boolean, columnId: keyof IconFormState) => {
    const consoleCheck = () => {
      console.log("inputValue", input);
      console.log("icons", icons);
      console.log("selectedFile", selectedFile);
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.checked;
      setIcons((prevIcons) => ({
        ...prevIcons,
        [columnId]: newValue,
      }));
    };

    return (
      <>
        <Checkbox
          size="small"
          checked={input}
          onChange={handleChange}
          onClick={(event) => checkboxAction(event)}
          sx={{ cursor: "pointer", pointerEvents: "auto" }}
        />
        <Button onClick={consoleCheck}>コンソールチェック</Button>
      </>
    );
  };

  const [registerPopoverOpen, setRegisterPopoverOpen] = useState(false);
  const registerButtonClick = () => {
    setRegisterPopoverOpen(true);
  };
  const registerPopupClose = () => {
    setRegisterPopoverOpen(false);
  };

  const postIconData = async (value: boolean) => {
    if (!value) {
      console.log("何も行いません");
      return;
    }

    const params = new FormData();
    params.append("icon_files", selectedFile ?? "");
    params.append("name", tenantName ?? "");
    params.append("alive", String(icons.alive));
    params.append("sales", String(icons.sales));
    params.append("sale_status", String(icons.sale_status));
    params.append("damage", String(icons.damage));
    params.append("m_tenant_id", String(parseInt(tenantId ?? "0", 10)));

    try {
      const response = await createIcon(params);
      console.log("アイコンを登録しました");
      console.log("レスポンスデータ:", response);
      console.log("入力データ", params);
    } catch (error) {
      if (
        axios.isAxiosError(error) &&
        error.response?.status === 400 &&
        error.response.data &&
        typeof error.response.data === "object" &&
        "status" in error.response.data &&
        error.response.data.status === "ng"
      ) {
        console.log("ステータスの組み合わせが重複しています");
        const message =
          "message" in error.response.data &&
          typeof error.response.data.message === "string"
            ? error.response.data.message
            : "";
        console.log("エラーメッセージ:", message);
      } else {
        console.error("エラーが発生しました:", error);
      }
    }
  };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth>
        <Box
          sx={{
            display: "flex",
            height: "56px",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px",
            borderBottom: "2px solid #CCC",
          }}
        >
          <Box
            sx={{
              paddingLeft: "8px",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            アイコン追加登録
          </Box>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Table sx={{ WebkitWritingMode: "horizontal-tb" }}>
          <TableBody>
            {columns.slice(0, 5).map((column) => {
              return (
                <TableRow role="checkbox" tabIndex={-1} key={column.id}>
                  <TableCell
                    sx={{
                      color: "outline.dark",
                      fontWeight: "bold",
                      boxSizing: "border-box",
                      width: "calc((100vw - 64px) / 2)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        WebkitWritingMode: "horizontal-tb",
                        height: "100%",
                        padding: "8px",
                      }}
                    >
                      {column.label}
                    </Box>
                  </TableCell>
                  <TableCell
                    sx={{
                      writingMode: "horizontal-tb",
                      boxSizing: "border-box",
                      width: "calc((100vw - 64px) / 2)",
                      overflowWrap: "break-word",
                      backgroundColor:
                        column.id === "file_key" ? "outline.main" : "#FFF",
                    }}
                  >
                    {column.icon === true ? (
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                          }}
                        >
                          <CardMedia
                            component="img"
                            alt="Image"
                            image={
                              (selectedFile &&
                                URL.createObjectURL(selectedFile)) ||
                              ImageIcon
                            }
                            sx={{
                              height: "60px",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                          <Button
                            size="small"
                            variant="contained"
                            component="label"
                          >
                            ファイル選択
                            <input
                              accept=".png, .svg,"
                              type="file"
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />
                          </Button>
                        </Box>
                      </Box>
                    ) : null}
                    {column.checkBox === true
                      ? CheckboxValidate(
                          icons[column.id as keyof IconFormState],
                          column.id as keyof IconFormState
                        )
                      : null}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}
        >
          <Button variant="contained" onClick={() => registerButtonClick()}>
            登録
          </Button>
        </Box>
      </Dialog>
      <PopoverRegister
        open={registerPopoverOpen}
        onClose={registerPopupClose}
        yesNo={(value) => postIconData(value)}
      />
    </>
  );
}
